// extracted by mini-css-extract-plugin
export default {"wrapper":"HoverPreview_wrapper__m5cot","overlay":"HoverPreview_overlay__SHj8D","playImg":"HoverPreview_playImg__qXtYy"};